import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CohortsComponent } from './pages/cohorts/cohorts.component';
import { CohortDetailsComponent } from './pages/cohort-details/cohort-details.component';
import { QuestionDetailsComponent } from './pages/question-details/question-details.component';
import { SpecialtiesListComponent } from './pages/specialties-list/specialties-list.component';
import { QuestionsComponent } from './pages/questions/questions.component';
import { InsightsDashboardComponent } from './pages/insights-dashboard/insights-dashboard.component';

const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'insights', component: InsightsDashboardComponent },
  { path: 'cohorts', component: CohortsComponent },
  { path: 'cohorts/:id', component: CohortDetailsComponent },
  { path: 'question/:id', component: QuestionDetailsComponent },
  { path: 'specialties', component: SpecialtiesListComponent },
  { path: 'questions', component: QuestionsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AskAyenRoutingModule { }
